import { gql } from '@apollo/client';

export const graphsWithFlyProviderQuery = gql`
  query GraphsWithFlyProviderQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      graphs {
        id
        variants {
          id
          router {
            id
            shard {
              id
              region {
                provider
              }
            }
          }
        }
      }
    }
  }
`;
